import React from 'react';
import './TargetStatus.css';

export default function TargetStatus({ targets, controller, won }) {
  // Build a mini connection graph showing which target pairs are connected
  const pairs = [];
  if (targets.length >= 2) {
    for (let i = 0; i < targets.length; i++) {
      for (let j = i + 1; j < targets.length; j++) {
        const a = targets[i];
        const b = targets[j];
        const aId = typeof a === 'string' ? a : (a.type === 'actor' ? 'a' : a.type === 'movie' ? 'm' : 't') + a.id;
        const bId = typeof b === 'string' ? b : (b.type === 'actor' ? 'a' : b.type === 'movie' ? 'm' : 't') + b.id;

        let connected = false;
        if (controller?.board?.cy) {
          // Check if there's a path between these targets on the board
          const aSel = controller.board.cy.getElementById(aId);
          const bSel = controller.board.cy.getElementById(bId);
          if (aSel.length && bSel.length) {
            try {
              const path = controller.board.cy.elements().aStar({
                root: aSel,
                goal: bSel,
              });
              connected = path.found;
            } catch {
              connected = false;
            }
          }
        }

        pairs.push({
          a: a._resolvedName || a.name || aId,
          b: b._resolvedName || b.name || bId,
          connected,
        });
      }
    }
  }

  const connectedCount = pairs.filter(p => p.connected).length;
  const totalPairs = pairs.length;

  return (
    <div className="target-status">
      <div className="target-status__pairs">
        {pairs.map((pair, i) => (
          <div
            key={i}
            className={`target-status__pair ${pair.connected ? 'target-status__pair--connected' : ''}`}
          >
            <span className="target-status__name">{pair.a}</span>
            <span className={`target-status__line ${pair.connected ? 'target-status__line--connected' : ''}`} />
            <span className="target-status__name">{pair.b}</span>
          </div>
        ))}
      </div>
      {won && (
        <span className="target-status__won">Connected!</span>
      )}
    </div>
  );
}
